import React from 'react';
import { ArrowRight, Newspaper, ChartNoAxesCombined, TrendingUp } from 'lucide-react';
import {Report} from "@rti/shared";
import FeedstockDaily from './FeedstockDaily';
import { useTheme } from '@/contexts/ThemeContext';

interface DashboardSidebarProps {
  onNavigate: (path: string) => void;
  hasEmployeeAccess: boolean;
  activeReports: Report[];
  useResinDashboards: boolean;
}
const showPetChemNews = false;

const DashboardSidebar: React.FC<DashboardSidebarProps> = ({
  onNavigate,
  hasEmployeeAccess,
  activeReports,
  useResinDashboards,
}) => {
  const { isDark } = useTheme();
  const cardText = isDark ? 'text-rs-off-white' : 'text-white';
  return (
    <div className="row-span-2 lg:col-span-1 sm:col-span-2 col-span-1 flex flex-col justify-between h-full w-full">
      {/* Weekly Drivers Card */}
      <div
        data-testid="weekly-drivers-button"
        className={`rounded-xl pt-5 px-3 flex items-center justify-end h-35 mb-2 bg-rs-rb2-gradient ${cardText} cursor-pointer stacked-images hover:opacity-90 transition-opacity`}
        onClick={() => onNavigate("/drivers")}
      >
        <div className="relative">
          <img className="w-sm" src="/PetChemChart.svg" alt="PetChem Chart" />
          <img className="w-sm" src="/Feedstock.svg" alt="Feedstock" />
        </div>
        <div className="flex items-center">
          Weekly Drivers
          <ArrowRight className="ml-3" size={25} />
        </div>
      </div>

      {/* PetroChemical News Card */}
      {hasEmployeeAccess && showPetChemNews && (
        <div
          className={`rounded-xl py-2 px-3 flex items-center justify-end h-20 mb-2 dashboard-red-gradient ${cardText} cursor-pointer stacked-images hover:opacity-90 transition-opacity relative`}
          onClick={() => onNavigate("/news")}
        >
          <div className="absolute bottom-1 left-3">
            <Newspaper className="ml-5 opacity-10 text-rs-red" size={75} />
          </div>
          <div className="flex items-center justify-end w-full">
            PetroChemical News
            <ArrowRight className="ml-3" size={25} />
          </div>
        </div>
      )}

      {/* Feedstock Panel */}
      <div className="rounded-xl py-2 px-3 mb-2  bg-rs-off-black text-rs-off-white flex items-center justify-center min-h-[300px]">
        <FeedstockDaily />
      </div>

      {/* PetChem Dashboard Card */}
      {activeReports.map((report, index) => {
        if ((report.abbreviation || '').toUpperCase() === 'PC') {
          return (
            <div
              key={index}
              className={`rounded-xl pt-5 px-3 flex items-center justify-between h-35 mb-2 dashboard-green-gradient sidebar-nav-card ${cardText} cursor-pointer stacked-images hover:opacity-90 transition-opacity relative`}
              onClick={() =>
                onNavigate(useResinDashboards ? '/marketIntel/petchem' : `/marketIntel/${report.report_id}`)
              }
              title="View PetroChemical Market Intel"
            >
              <div className="absolute bottom-5 left-0">
                <ChartNoAxesCombined className="ml-5 opacity-5 text-rs-green" size={105} />
              </div>
              <div className="flex items-center justify-end w-full">
                View PetChem Market Intel
                <ArrowRight className="ml-3" size={25} />
              </div>
            </div>
          );
        }
        return null;
      })}
      {(
        <div
          className={`rounded-xl py-2 px-3 flex items-center justify-end h-20 mb-2 dashboard-purple-gradient sidebar-nav-card ${cardText} cursor-pointer stacked-images hover:opacity-90 transition-opacity relative`}
          onClick={() => onNavigate("/eia-forecast")}
        >
          <div className="absolute bottom-1 left-3">
            <TrendingUp className="ml-5 opacity-10 text-shadow-rs-blue-dash" size={75} />
          </div>
          <div className="flex items-center justify-end w-full">
            EIA Forecast Analysis
            <ArrowRight className="ml-3" size={25} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardSidebar;
